<template>
    <div class="service-package-selection">
        <div :class="['service-package-selection-list', { single: addons.length === 1 }]">
            <ServicePackageCard
                v-for="addon in addons"
                class="service-package-selection-list-item"
                :key="addon.Id"
                :addon="addon"
                :onSelect="onSelect"
                :selectedAddon="selectedAddon" />
        </div>
        <Link
            v-if="link"
            class="service-package-selection-link"
            :href="link"
            :label="t({ key: 'shared.extended_more_info' })"
            :onClick="() => logStatsigBookingServicePackageInteraction('ReadMore')"
            target="_blank" />
    </div>
</template>

<script lang="ts">
    import { defineComponent, PropType, computed } from 'vue';
    import { t } from '@shared/helpers/translation';
    import { useStore } from '@/store';
    import { logStatsigBookingServicePackageInteraction } from '@/tracking/statsig/booking.functions';
    import { UpSellAddonServicePackage } from '@/api/MyBookingSession/myBookingSession.interfaces';
    import ServicePackageCard from './ServicePackageCard/ServicePackageCard.vue';
    import Link from '@ui/components/Link/Link.vue';
    import { Links } from '@/api/MyBooking/myBooking.interfaces';

    export default defineComponent({
        name: 'Selection',
        methods: { logStatsigBookingServicePackageInteraction, t },
        components: { Link, ServicePackageCard },
        props: {
            addons: {
                type: Array as PropType<UpSellAddonServicePackage[]>,
                required: true,
            },
            selectedAddon: {
                type: Object as PropType<UpSellAddonServicePackage | undefined>,
                required: true,
            },
            onSelect: {
                required: true,
                type: Function as PropType<(addon: UpSellAddonServicePackage) => void>,
            },
        },
        setup() {
            const store = useStore();
            const link = computed(() => {
                const links: Links = store.getters['myBooking/getLinks'];
                return links?.termsAndCondition; // apply anchor when provided
            });

            return {
                link,
            };
        },
    });
</script>

<style lang="scss" scoped>
    @forward 'Selection';
</style>
